import { useCallback } from "react";
import { acquireToken } from "../../authentication/utils/authUtils";
import { getPhoneConfig } from "../api/phoneApi";

export const usePhoneConfig = ({ instance, account }) => {
  const getAccessToken = useCallback(async () => {
    if (!account) {
      throw new Error("Microsoft account is not ready yet.");
    }

    const token = await acquireToken(instance, account);
    return token.accessToken;
  }, [account, instance]);

  const loadPhoneConfig = useCallback(async () => {
    const accessToken = await getAccessToken();
    return getPhoneConfig(accessToken);
  }, [getAccessToken]);

  return {
    getAccessToken,
    loadPhoneConfig,
  };
};
